import { render, staticRenderFns } from "./OverviewV2.vue?vue&type=template&id=c3551ece"
import script from "./OverviewV2.vue?vue&type=script&lang=js"
export * from "./OverviewV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports